module.exports = __webpack_public_path__ + "static/media/article-4-option-3-1785111.c672f634.png";